module.exports = __webpack_public_path__ + "img/auditorium.9e845fcb.svg";